import * as React from 'react'
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { InputField } from '../../../../components'
import { RegisterResultModal } from '../components/RegisterResultModal'
import { toast } from 'react-toastify'
import { authService } from '../../../../../services'

type RegisterProps = {
  isShow: boolean
}
type RegisterState = {
  isShow: boolean,
  data: IRegisterInfo
  isLoading: boolean
  error?: IError,
  rePassword: string,
  showResultPopup: boolean,
  user?: IUser,
}

export class Register extends React.Component<RegisterProps, RegisterState> {
  constructor(props: RegisterProps) {
    super(props)
    this.state = {
      isShow: false,
      data: {
        username: '',
        password: '',
        steamId: '',
        email: '',
        offerLink: ''
      },
      rePassword: '',
      isLoading: false,
      error: undefined,
      showResultPopup: false
    }
    this.toggle = this.toggle.bind(this)
  }

  componentWillReceiveProps(nextProps: RegisterProps) {
    this.setState({
      isShow: nextProps.isShow
    })
  }

  toggle() {
    this.setState({
      isShow: !this.state.isShow
    })
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = event.target
    const {data} = this.state
    let rePassword = ''
    if (name !== 'rePassword') {
      data[name] = value
      this.setState({
        data
      })
    } else {
      rePassword = value
      this.setState({
        rePassword: value
      })
    }

  }

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const {data, rePassword} = this.state

    if (data.password !== rePassword) {
      toast.error('Xác nhận mật khẩu chưa đúng!')
      return
    }
    this.setState({isLoading: true})

    authService.register(data)
      .then(user => {
        this.setState({
          isLoading: false,
          user: user,
          showResultPopup: true,
        })
      })
      .catch(error => {
        toast.error('Đăng ký không thành công! Thông tin: ' + error.message)
        this.setState({isLoading: false, error})
      })
  }

  toggleRegisterResult = () => {
    this.setState({
      showResultPopup: !this.state.showResultPopup,
      isShow: false
    })
  }

  render() {
    const {isShow, error, data, isLoading, rePassword, showResultPopup, user} = this.state
    const errorDetails: any = (error && error.details) ? error.details : {}
    return (
      <Modal isOpen={isShow} toggle={this.toggle}>
        <ModalHeader>Register</ModalHeader>
        <ModalBody>
          <form name="registerForm" onSubmit={this.onSubmit}>
            {error && error.message && <Alert color="danger">{error.message}</Alert>}
            <InputField
              name="username"
              value={data.username}
              placeholder="Tài khoản"
              iconClass="icon-user"
              disabled={isLoading}
              autoFocus={true}
              error={errorDetails.username}
              onChange={this.onChange}
            />
            <InputField
              name="email"
              value={data.email}
              placeholder="Email"
              iconClass="icon-envelope"
              disabled={isLoading}
              autoFocus={true}
              error={errorDetails.email}
              onChange={this.onChange}
            />
            <InputField
              type="password"
              name="password"
              value={data.password}
              placeholder="Mật khẩu"
              iconClass="icon-lock"
              disabled={isLoading}
              error={errorDetails.password}
              onChange={this.onChange}
            />
            <InputField
              type="password"
              name="rePassword"
              value={rePassword}
              placeholder="Nhập lại mật khẩu"
              iconClass="icon-key"
              disabled={isLoading}
              error={errorDetails.rePassword}
              onChange={this.onChange}
            />
            <InputField
              name="steamId"
              value={data.steamId}
              placeholder="Steam ID in 5etop"
              iconClass="icon-home"
              disabled={isLoading}
              error={errorDetails.steamId}
              onChange={this.onChange}
            />
            <InputField
              name="offerLink"
              value={data.offerLink}
              placeholder="Steam offer URL"
              iconClass="icon-link"
              disabled={isLoading}
              error={errorDetails.offerLink}
              onChange={this.onChange}
            />
            <Row>
              <Col className="text-right">
                <Button type="submit" color="primary" disabled={isLoading}>
                  {isLoading && <i className="fa fa-spinner fa-spin"/>}
                  {isLoading ? ' Đang đăng ký...' : 'Đăng ký'}
                </Button>
              </Col>
            </Row>
            {user &&
            <RegisterResultModal
              isShow={showResultPopup}
              user={user}
              toggle={this.toggleRegisterResult}
            />}
          </form>
        </ModalBody>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Register/containers/Register.tsx